import { createSlice } from '@reduxjs/toolkit';
const userDetails: any = {};
const filters: any = {};
const transaction: any = {};

const userReducer = createSlice({
	name: 'locations',
	initialState: {
		isLoading: false,
		users: [],
		userDetails,
		filters,
		transaction,
		transactions: [],
	},
	reducers: {
		setUsersIsLoading: (state) => {
			state.isLoading = true;
		},
		resetUsersIsLoading: (state) => {
			state.isLoading = false;
		},
		setUsers: (state, action) => {
			state.users = action.payload;
		},
		resetUsers: (state) => {
			state.users = [];
		},
		setUser: (state, action) => {
			state.userDetails = action.payload;
		},

		resetUser: (state) => {
			state.userDetails = {};
		},

		setUsersFilters: (state, action) => {
			state.filters = action.payload;
		},

		resetUsersFilters: (state) => {
			state.filters = {};
		},
		setUserTransactions: (state, action) => {
			state.transactions = action.payload;
		},

		resetUserTransactions: (state) => {
			state.transactions = [];
		},
		setUserTransaction: (state, action) => {
			state.transaction = action.payload;
		},

		resetUserTransaction: (state) => {
			state.transaction = {};
		},
	},
});
export const {
	setUsersIsLoading,
	resetUsersIsLoading,
	setUser,
	resetUser,
	setUsers,
	resetUsers,
	setUsersFilters,
	resetUsersFilters,
	setUserTransaction,
	resetUserTransaction,
	setUserTransactions,
	resetUserTransactions,
} = userReducer.actions;
export default userReducer.reducer;
